<template>
  <section  class="elementor-section elementor-top-section elementor-element elementor-element-e824de3 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="e824de3" data-element_type="section" data-e-type="section" data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
    <div class="elementor-container elementor-column-gap-no">
      <div class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-432a640" data-id="432a640" data-element_type="column" data-e-type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-f2b656b elementor-invisible elementor-widget elementor-widget-heading" data-id="f2b656b" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;fadeIn&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;,&quot;_animation_delay&quot;:200}" data-widget_type="heading.default">
            <div class="elementor-widget-container">
              <h2 class="elementor-heading-title elementor-size-default">Building for the best.</h2>
            </div>
          </div>
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-54165bc elementor-widget elementor-widget-text-editor" data-id="54165bc" data-element_type="widget" data-e-type="widget" data-widget_type="text-editor.default">
            <div class="elementor-widget-container">
              To explore and go after new ways to build, we’ve gathered the people, innovations, and partnerships that can anticipate and overcome new challenges.
            </div>
          </div>
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-89a2155 elementor-align-justify vamtam-btn-text-align vamtam-has-underline-anim elementor-widget elementor-widget-button" data-id="89a2155" data-element_type="widget" data-e-type="widget" data-widget_type="button.default">
            <div class="elementor-widget-container">
              <div class="elementor-button-wrapper">
                <a class="elementor-button elementor-button-link elementor-size-sm" href="/vision-mission">
                  <span class="elementor-button-content-wrapper">
                    <span class="elementor-button-icon">
                      <i aria-hidden="true" class="vamtamtheme- vamtam-theme-arrow-right"></i>
                    </span>
                    <span class="elementor-button-text">Innovation</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-a5d52ba elementor-align-justify vamtam-btn-text-align vamtam-has-underline-anim elementor-widget elementor-widget-button" data-id="a5d52ba" data-element_type="widget" data-e-type="widget" data-widget_type="button.default">
            <div class="elementor-widget-container">
              <div class="elementor-button-wrapper">
                <a class="elementor-button elementor-button-link elementor-size-sm" href="/about-us">
                  <span class="elementor-button-content-wrapper">
                    <span class="elementor-button-icon">
                      <i aria-hidden="true" class="vamtamtheme- vamtam-theme-arrow-right"></i>
                    </span>
                    <span class="elementor-button-text">A strong foundation</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-0c4d478 elementor-hidden-tablet elementor-hidden-mobile" data-id="0c4d478" data-element_type="column" data-e-type="column">
        <div class="elementor-widget-wrap"></div>
      </div>
      <div class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-f7fc2da" data-id="f7fc2da" data-element_type="column" data-e-type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-1289a9d elementor-widget__width-auto elementor-widget elementor-widget-counter" data-id="1289a9d" data-element_type="widget" data-e-type="widget" data-widget_type="counter.default">
            <div class="elementor-widget-container">
              <div class="elementor-counter">
                <div class="elementor-counter-number-wrapper">
                  <span class="elementor-counter-number-prefix"></span>
                  <span class="elementor-counter-number" data-duration="1000" data-to-value="30" data-from-value="0" data-delimiter=",">0</span>
                  <span class="elementor-counter-number-suffix">+</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-e70fca0 elementor-widget elementor-widget-text-editor" data-id="e70fca0" data-element_type="widget" data-e-type="widget" data-widget_type="text-editor.default">
            <div class="elementor-widget-container">
              Years Experience
            </div>
          </div>
          <div class="elementor-element elementor-element-22b6a9a elementor-widget-divider--view-line elementor-widget elementor-widget-divider" data-id="22b6a9a" data-element_type="widget" data-e-type="widget" data-widget_type="divider.default">
            <div class="elementor-widget-container">
              <div class="elementor-divider">
                <span class="elementor-divider-separator"></span>
              </div>
            </div>
          </div>
          <div class="elementor-element elementor-element-149fc7a elementor-widget__width-auto elementor-widget elementor-widget-counter" data-id="149fc7a" data-element_type="widget" data-e-type="widget" data-widget_type="counter.default">
            <div class="elementor-widget-container">
              <div class="elementor-counter">
                <div class="elementor-counter-number-wrapper">
                  <span class="elementor-counter-number-prefix"></span>
                  <span class="elementor-counter-number" data-duration="1500" data-to-value="100" data-from-value="0" data-delimiter=",">0</span>
                  <span class="elementor-counter-number-suffix">+</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-5b887cd elementor-widget elementor-widget-text-editor" data-id="5b887cd" data-element_type="widget" data-e-type="widget" data-widget_type="text-editor.default">
            <div class="elementor-widget-container">
              Clients
            </div>
          </div>
          <div class="elementor-element elementor-element-f9cf256 elementor-widget-divider--view-line elementor-widget elementor-widget-divider" data-id="f9cf256" data-element_type="widget" data-e-type="widget" data-widget_type="divider.default">
            <div class="elementor-widget-container">
              <div class="elementor-divider">
                <span class="elementor-divider-separator"></span>
              </div>
            </div>
          </div>
          <div class="elementor-element elementor-element-e631768 elementor-widget__width-auto elementor-widget elementor-widget-counter" data-id="e631768" data-element_type="widget" data-e-type="widget" data-widget_type="counter.default">
            <div class="elementor-widget-container">
              <div class="elementor-counter">
                <div class="elementor-counter-number-wrapper">
                  <span class="elementor-counter-number-prefix"></span>
                  <span class="elementor-counter-number" data-duration="1500" data-to-value="200" data-from-value="0" data-delimiter=",">0</span>
                  <span class="elementor-counter-number-suffix">+</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-cc4a7da elementor-widget elementor-widget-text-editor" data-id="cc4a7da" data-element_type="widget" data-e-type="widget" data-widget_type="text-editor.default">
            <div class="elementor-widget-container">
              Projects
            </div>
          </div>
          <div class="elementor-element elementor-element-e631768 elementor-widget__width-auto elementor-widget elementor-widget-counter" data-id="e631768" data-element_type="widget" data-e-type="widget" data-widget_type="counter.default">
            <div class="elementor-widget-container">
              <div class="elementor-counter">
                <div class="elementor-counter-number-wrapper">
                  <span class="elementor-counter-number-prefix"></span>
                  <span class="elementor-counter-number" data-duration="1500" data-to-value="1000" data-from-value="0" data-delimiter=",">0</span>
                  <span class="elementor-counter-number-suffix">+</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-cc4a7da elementor-widget elementor-widget-text-editor" data-id="cc4a7da" data-element_type="widget" data-e-type="widget" data-widget_type="text-editor.default">
            <div class="elementor-widget-container">
              Experts
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import '@splidejs/vue-splide/css';
  import { onMounted } from 'vue'
  import { useHomeContentStore } from '@/stores/homeContentStore'

  const baseUploadURL = process.env.VUE_APP_API_URL;

  export default {
    name: 'FactsSectionComponent',
    setup() {
      const homeContentStore = useHomeContentStore()

      onMounted(async () => {
        await homeContentStore.fetchContentPage()
      })

      return {
        homeContentStore
      }
    },
    data() {
      return{
        baseUploadURL: baseUploadURL,
      }
    },
  }
</script>

<style scoped>
  .elementor-kit-5 h2 {
    font-size: 40px;
  }
</style>